import React from "react";
import { Field } from "react-final-form";
import Checkbox from "../field/Checkbox";

const FormCheckbox = props => (
  <Field name={props.name}>
    {({ input, meta }) => {
      const { name, value } = input,
        { onPress } = props;

      return (
        <Checkbox
          {...props}
          value={value}
          error={meta.error}
          onPress={checked => {
            input.onChange(checked);

            if (onPress) {
              onPress(checked);
            }
          }}
        />
      );
    }}
  </Field>
);

export default FormCheckbox;
